import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import { Observable } from 'knockout';
import AttachmentControlVM from './control';
import './select.html';

export interface AttachmentSelectControlVMConfig {
    isSelected: Observable<boolean>
}

@injectable()
export default class AttachmentSelectControlVM extends AttachmentControlVM {
    isSelected: Observable<boolean>

    constructor(
        @inject(wccModules.componentConfig) config: AttachmentSelectControlVMConfig,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo
    ) {
        super(info);

        this.isSelected = config.isSelected;

        ko.applyBindingsToNode(info.element, {
            'css': {
                'wcc-attachment-controls__control--active': this.isSelected
            }
        });
    }

    click() {
        this.toggle();
    }

    private toggle() {
        this.isSelected.toggle();
    }
}